export type GlDetailDescriptionFields = {
    description?: string | null;
    voucherNo?: string | null;
    invoiceNo?: string | null;
    invoiceDate?: string | null;
    chequeNo?: string | null;
    details?: string | null;
};

/** Merge GL detail text fields for transaction test description (space-separated, de-duplicated). */
export function buildGlDetailDescription(fields: GlDetailDescriptionFields): string {
    const parts = [
        fields.description,
        fields.voucherNo,
        fields.invoiceNo,
        fields.invoiceDate,
        fields.chequeNo,
        fields.details,
    ]
        .map((v) => String(v ?? '').trim())
        .filter(Boolean);

    const seen = new Set<string>();
    const unique: string[] = [];
    for (const part of parts) {
        const key = part.toLowerCase();
        if (seen.has(key)) continue;
        seen.add(key);
        unique.push(part);
    }
    return unique.join(' ');
}
